<template>
  <b-container>
    <div v-if="this.$route.params.slug !== undefined">
      <b-col v-if="form.content_type==1" class="text-left">
        <router-link :to="{ name: 'PostsDashboard' }">
          <b-button pill variant="purple" class="ml-1 mb-1"
          > بازگشت به صفحه پست ها
          </b-button
          >
        </router-link>
      </b-col>

      <b-col v-if="form.content_type==0" class="text-left">
        <router-link :to="{ name: 'PagesDashboard' }">
          <b-button pill variant="purple" class="ml-1 mb-1"
          > بازگشت به صفحه برگه ها
          </b-button
          >
        </router-link>
      </b-col>
    </div>

    <b-form @submit.prevent="onSubmit">
      <h5>{{ title }}</h5>

      <name-and-link-manager v-if="form.content_type == 1"
                             :router-link="{ name: 'SinglePost', params: { slug: form.titleAndSlug.link } }"
                             :label="'عنوان'"
                             v-model="form.titleAndSlug"
                             :validation="$v.form.titleAndSlug.name">

        <date-picker
            auto-submit
            v-model="form.created_at"
            type="datetime"
            class="datetime-input col-lg-3"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD HH:mm:ss"
            placeholder="تاریخ و ساعت را انتخاب کنید"
        />
        <published-checkbox   label="وضعیت انتشار" v-model="form.status"/>
      </name-and-link-manager>

      <name-and-link-manager v-else
                             :router-link="{ name: 'SinglePage', params: { slug: form.titleAndSlug.link } }"
                             :label="'عنوان'"
                             v-model="form.titleAndSlug"
                             :validation="$v.form.titleAndSlug.name">
        <date-picker
            auto-submit
            v-model="form.created_at"
            type="datetime"
            class="datetime-input col-lg-3"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD HH:mm:ss"
            placeholder="تاریخ و ساعت را انتخاب کنید"
        />
        <published-checkbox  label="وضعیت انتشار" v-model="form.status"/>

      </name-and-link-manager>

      <div class="row mt-3">
        <div class="col">
          <span class="mt-3 d-inline-block" v-if="$route.params.slug != undefined"
                @click="copyToClipBoard(`${findAttributeOnSiteInfo('host')[0]}/api/s/c-${form.id}`)">
        لینک کوتاه
        <b-icon-link45deg/>
      </span>
          <div class="my-3" v-if="$route.params.slug != undefined">
            <qr-generator
                :qr-value="dashboardLinkToSiteLink(contentType(),{slug:form.titleAndSlug.link})"/>
          </div>
        </div>

      </div>


      <b-row class=" mb-2"> عکس</b-row>
      <b-row>
        <b-col sm="3" md="3">
          <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                        :validation="$v.form.mainImage"></single-image>
        </b-col>
      </b-row>

      <div class="row mt-3">
        <div class="col-lg-6">
          <label for="">نویسنده</label>

          <UserFilter2 :roles="[1,2,3,4]" @change_user="setAuthor" :user="form.author"/>
        </div>
      </div>

      <b-row class="mt-5">مشخصات</b-row>
      <b-row class="mt-2">
        <radio-box :label="'انتخاب نوع محتوا'" :radioItems="content_typeList" v-model="form.content_type"
                   :validation="$v.form.content_type" :isBrand="false"/>
        <languageBox v-model="form.language_id" :validation="$v.form.language_id"/>

      </b-row>

      <b-row>
        <check-box-manager :CheckBoxItems="categories" :label="'انتخاب دسته بندی'"
                           :selectedCheckBoxes="form.selectedCategory" :validation="$v.form.selectedCategory"/>

        <div class="col-lg-6 p-0 h-100">
          <label>نویسندگان</label>
          <UserFilter1 :roles="[1,2,3,4]" :users-prop="form.author_contributes"
                       @selected_users="setAuthorContribute"
                       class="col-12 h-100"/>
        </div>

      </b-row>

      <b-row class="mt-5">
        <form-group :validations="$v.form.abstraction" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>چکیده</label>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.abstraction" :options="defaultToolbar"></vue2-tinymce-editor>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>

      <b-row class="mt-5">

        <form-group :validations="$v.form.body" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>متن</label>
            <b-row>
              <b-col lg="4">
                <add-iframe-to-editor @iframe-handler="iframeHandlerFunction"/>
              </b-col>
            </b-row>
            <div class="form-group">
              <published-checkbox label="ادیتور پیشرفته" v-model="form.editor_mode"/>
              <div class="row justify-content-end">
                <div class="text-right">
                  <b-button class="mx-3 mb-2" v-b-modal.modal-xl> اضافه کردن مدیا</b-button>

                  <b-modal id="modal-xl"
                           title=""
                           centered
                           hide-footer
                           content-class=""
                           size="xl"


                  >
                    <file-manager @file-selected="insertFileInEditor"/>
                  </b-modal>

                  <b-button class="mx-3 mb-2" @click="resetModal" v-b-modal.add-component>اضافه کردن کامپوننت</b-button>

                  <b-modal id="add-component"
                           ref="add-component"
                           title=""
                           centered
                           hide-footer
                           content-class=""
                           size="xl">

                    <div class="text-right" dir="rtl">

                      <span class="mb-0">انتخاب کامپوننت</span>
                      <select class="form-control px-4 my-4"
                              v-model="selected_component">
                        <option v-for="item in editor_components" :value="item">{{
                            item.name
                          }}
                        </option>
                      </select>


                      <div class="">
                        <div v-for="(item,key) in selectedComponentProps()">

                          <div class="form-group" v-if="item['type'] == 'Array' && item['source'] == 'file-manager'">
                            <label for="">{{ key }}</label>
                            <b-button class="mx-3 mb-2 d-block" @click="setModalItem(key)"
                                      v-b-modal.add-material-to-component>
                              اضافه کردن عکس
                            </b-button>

                            <div class="m-3 d-inline-block text-center" v-for="(arrayItem,index) in item['default']">
                              <img class="d-inline-block rounded mx-1"
                                   :src="arrayItem['image']" style="width: 150px;height: 150px;object-fit: contain"
                                   :alt="arrayItem['alt']">
                              <input class="form-control my-2" type="text" v-model="arrayItem['alt']">
                              <div class="d-flex justify-content-center">
                                <b-icon @click="moveItem(item['default'],index,'up')" icon="chevron-right"
                                        class="mx-4 h5  "/>
                                <b-icon @click="moveItem(item['default'],index,'down')" icon="chevron-left"
                                        class="mx-4  h5 "/>
                                <b-icon @click="removeItem(item['default'],index)" icon="trash"
                                        class="mx-4  h5 "/>

                              </div>
                            </div>

                          </div>
                          <div class="form-group" v-else>
                            <label for="">{{ key }}</label>
                            <input type="text" v-model="item['default']" class="form-control">
                          </div>
                        </div>
                      </div>


                      <b-modal id="add-material-to-component"
                               title=""
                               centered
                               hide-footer
                               content-class=""
                               size="xl">
                        <file-manager @file-selected="setValueOfImage"/>
                      </b-modal>


                      <div class="text-center">
                        <button @click="submitComponent" class="btn btn-primary w-75">ثبت</button>
                      </div>


                    </div>
                  </b-modal>
                </div>
              </div>

              <vue2-tinymce-editor v-model="form.body" :options="defaultToolbar"
                                   id="main-editor"
                                   ref="tinymceEditor"></vue2-tinymce-editor>

            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-row>
      <key-words-manager :keyWords="form.keyWords" :TableItems="form.table"/>

      <b-row class="my-5">
        <b-col md="8" class="m-auto">
          <b-button pill type="submit" variant="purple" class="w-100"
          >تایید
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>


</template>
<script>
import router from '@/router';
import {mapGetters} from "vuex";
import category from "../product/category.vue";
import {required, numeric} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import NameAndLinkManager from "./FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "./FormItems/PublishedCheckbox.vue";
import SingleImage from "./FormItems/SingleImage.vue";
import RadioBox from "./FormItems/RadioBox.vue";
import CheckBoxManager from "./FormItems/CheckBoxManager.vue";
import FormInput from "./FormItems/FormInput.vue";
import FormTextArea from "./FormItems/FormTextArea.vue";
import KeyWordsManager from "./FormItems/KeyWordsManager.vue";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import AddIframeToEditor from "./FormItems/AddIframeToEditor";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import languageBox from "../Language/LanguageBox";
import {Vue2TinymceEditor} from "vue2-tinymce-editor";
import QrGenerator from "@/plugin/components/genralComponents/QrGenerator.vue";
import FileManager from "@/plugin/views/dashboard/FileManager.vue";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import UserFilter1 from "@/plugin/components/dashboard/Filters/User/UserFilter1.vue";
import UserFilter2 from "@/plugin/components/dashboard/Filters/User/UserFilter2.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "CreateContentLayout",
  components: {
    UserFilter2,
    UserFilter1,
    FileManager,
    QrGenerator,
    category,
    FormGroup,
    AddIframeToEditor,
    FormErrorsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    KeyWordsManager,
    languageBox,
    Vue2TinymceEditor,
    datePicker: VuePersianDatetimePicker,
  },
  props: ["title", "submitFunction"],
  data() {
    return {
      fields: [
        {key: "name", label: "کلمه کلیدی"},
        {key: "action", label: ""},
      ],
      form: {
        titleAndSlug: {name: "", link: ""},
        mainImage: [],
        content_type: '',
        selectedCategory: [],
        free: null,
        course_status: null,
        section_name: null,
        status: false,
        abstraction: "",
        body: "",
        keyWords: [],
        table: [],
        mainPreview: "",
        language_id: '',
        editor_mode: 0,
        created_at: null,
      },
      content_typeList: [
        {name: "پست", id: '1'},
        {name: "برگه", id: '0'},
      ],
      defaultToolbar,
      showModal: false,
      selected_component_mode: null,
      selected_component_index: null,
      selected_component: {},
      editor_components: [
        {
          name: "m-slider-301",
          props: {
            autoPlay: {
              default: false,
            },
            autoPlayDuration: {
              default: 1000,
            },
            images: {
              type: 'Array',
              source: 'file-manager',
              default: [],
              sample: {
                value: "https://news-cdn.varzesh3.com/pictures/2026/01/26/A/5wasoss30.webp?w=350",
                alt: "1",
              }
            },
          }
        },
        {
          name: "m-slider-302",
          props: {
            swiperPerViewSM: {
              default: 2,
            },
            swiperPerViewMD: {
              default: 3,
            },
            swiperPerViewLG: {
              default: 4,
            },
            autoPlay: {
              default: false,
            },
            autoPlayDuration: {
              default: 1000,
            },
            images: {
              type: 'Array',
              source: 'file-manager',
              default: [],
              sample: {
                value: "https://news-cdn.varzesh3.com/pictures/2026/01/26/A/5wasoss30.webp?w=350",
                alt: "1",
              }
            },

          }
        },
        {
          name: "m-section-200",
          props: {
            imageBefore: {
              type: 'string',
              default: 'https://picsum.photos/1280/720'
            },
            imageAfter: {
              type: 'string',
              default: 'https://picsum.photos/1280/720'
            },
            direction: {
              type: 'string',
              default: 'horizontal',
              options: ['vertical', 'horizontal']
            },
            beforeText: {
              type: 'string',
              default: "قبل"
            },
            afterText: {
              type: 'string',
              default: "بعد"
            }
          },
        }
      ]
    };
  },
  validations: {
    form: {
      titleAndSlug: {name: {required}},
      selectedCategory: {required},
      content_type: {required},
      abstraction: {required},
      body: {required},
      language_id: {required},
      created_at: {},
      mainImage: {
        required: (value) => {

          return router.currentRoute.params.slug != undefined || value.length !== 0

        }
      }
    },
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
    }),
  },
  methods: {
    nowData() {
      const now = new Date();

      const date =
          now.getFullYear() + '-' +
          String(now.getMonth() + 1).padStart(2, '0') + '-' +
          String(now.getDate()).padStart(2, '0') + ' ' +
          String(now.getHours()).padStart(2, '0') + ':' +
          String(now.getMinutes()).padStart(2, '0') + ':' +
          String(now.getSeconds()).padStart(2, '0');
      return date
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    removeAmpOnEditor(content) {
      return content.replaceAll('&amp;', "&")
    },
    onSubmit() {
      if (this.invalid()) {
        this.form.body = this.form.body.replaceAll('v-resize', '').replaceAll('<iframe ', '<iframe v-resize ')
        this.form.body = this.removeAmpOnEditor(this.form.body)
        this.form.abstraction = this.removeAmpOnEditor(this.form.abstraction)
        const form = {title: this.form.titleAndSlug.name, slug: this.form.titleAndSlug.link, ...this.form};
        this.submitFunction(form);
      }
    },
    iframeHandlerFunction(iframe) {
      this.form.body += iframe;
    },
    async setContent() {
      let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
      const routerslug = this.$route.params.slug;
      if (routerslug !== undefined) {
        this.form.titleAndSlug.link = routerslug;
        this.$store
            .dispatch("Content/getDashboardContent", this.form.titleAndSlug.link)
            .then(async (res) => {
              this.form.titleAndSlug.name = await res.title;
              this.form.id = await res.id;
              this.form.titleAndSlug.link = await res.slug;
              this.form.content_type = await res.content_type
              this.form.status = await res.status ? true : false;
              this.form.mainPreview = await res.thumbnail;
              this.form.free = await res.free;
              this.form.course_status = await res.course_status;
              this.form.section_name = await res.section_name;
              this.form.author = await res.author;
              this.form.author_contributes = await res.author_contributes;
              this.form.description = await res.description;
              this.form.abstraction = await res.abstraction;
              this.form.created_at = await res.created_at;
              this.form.body = await res.body;
              this.form.editor_mode = await res.editor_mode ? true : false;
              language_id = await res.language_id;

              this.form.selectedCategory = []

              await res.category.forEach((category) => {
                this.form.selectedCategory.push(category)
              });

              document.getElementById(`item_${this.form.content_type}`).click();
              document.getElementById(`language_item_${language_id}`).click();
              this.form.keyWords = []
              this.form.table = []
              res.keywords.forEach((keyword) => {
                this.form.keyWords.push(keyword.keyword);
                this.form.table.push({name: keyword.keyword});
              });
            })
            .catch((err) => {
              console.log(err);
            });
      } else {
        this.form.author = this.$store.getters['User/getProfile']
        document.getElementById(`language_item_${language_id}`).click();
      }
    },
    copyToClipBoard(value) {
      navigator.clipboard.writeText(value);
      toast('عملیات با موفقیت انجام شد', 'کپی شد.', 'success')
    },
    contentType() {
      return this.form.content_type == 1 ? 'SinglePost' : 'SinglePage'
    },
    handleEscape(event) {
      if (event.key === "Escape") {
        this.showModal = false;
      }
    },
    insertFileInEditor(fileUrl) {
      const editor = this.$refs.tinymceEditor.editor;
      if (!editor) return;

      // مثال: اگر فایل تصویر هست، تگ img اضافه کن
      const ext = fileUrl.split('.').pop().toLowerCase();
      let insertHtml = '';

      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
        insertHtml = `<img src="${fileUrl}" alt="تصویر"/>`;
      } else if (['mp4', 'webm', 'ogg'].includes(ext)) {
        insertHtml = `<video controls src="${fileUrl}"></video>`;
      } else {
        // فایل غیر قابل نمایش (مثلاً pdf، docx و...)
        insertHtml = `<a href="${fileUrl}" target="_blank">${fileUrl}</a>`;
      }

      editor.execCommand('mceInsertContent', false, insertHtml);
    },
    waitForTinyMCE() {
      const tryGetEditor = () => {
        const comp = this.$refs.tinymceEditor;
        if (!comp) return null;

        // حالت‌های مختلفی که ممکنه داشته باشه
        return comp.editor || (comp.getEditor && comp.getEditor()) || comp.tinymce || null;
      };

      const timer = setInterval(() => {
        const editor = tryGetEditor();

        if (editor && editor.on) {
          clearInterval(timer);

          // رویداد کلیک داخل iframe
          editor.on("click", this.onEditorClick);

          // اگر خواستی فقط وقتی فوکوس گرفت:
          // editor.on("focus", this.onEditorClick);
        }
      }, 100);

      // برای اینکه اگر یه وقت ادیتور بالا نیومد، forever loop نشه
      setTimeout(() => clearInterval(timer), 5000);
    },
    onEditorClick(e) {
      const el = e.target?.closest?.('[data-component="true"]');
      if (el) {
        this.selected_component_mode = el
        this.selected_component = JSON.parse(el.getAttribute('data-raw-data'))
        this.$refs['add-component'].show()
      }
    },
    resetModal() {
      this.selected_component = {}
    },
    detachTinyEvents() {
      const comp = this.$refs.tinymceEditor;
      const editor =
          comp?.editor || (comp?.getEditor && comp.getEditor()) || comp?.tinymce;

      if (editor && editor.off) {
        editor.off("click", this.onEditorClick);
      }
    },
    setValueOfImage(fileUrl) {
      let sample = Object.assign({}, this.selected_component.props[this.selected_component_index]['sample']);
      sample['image'] = fileUrl
      this.selected_component.props[this.selected_component_index]['default'].push(sample)
    },
    setModalItem(key) {
      this.selected_component_index = key
    },
    editorComponentHandler(event) {
      console.log('editorComponentHandler', event)
    },
    selectedComponentProps() {
      if (this.selected_component.length === 0) {
        return []
      }
      return this.selected_component?.props
    },
    camelTokKebab(str) {
      return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    },
    submitComponent() {
      let componentName = this.selected_component.name
      let componentProps = this.selected_component.props
      let componentRawJson = JSON.stringify(this.selected_component)
      let propsResult = ''

      Object.keys(componentProps).forEach((key) => {
        let value = componentProps[key]['default'];


        if (key === 'images') {
          let images = [];
          value.forEach(image => {
            images.push({
              value: image['image'],
              alt: image['alt']
            });
          });
          images = JSON.stringify(images, null, 2);

          propsResult += ` :${this.camelTokKebab(key)}='${images}' `;
        } else if (componentProps[key]['type'] == 'string' && key != 'images') {
          // از نام کلید واقعی استفاده کنید
          propsResult += ` ${this.camelTokKebab(key)}='${value}' `;
        } else {
          // از نام کلید واقعی استفاده کنید
          propsResult += ` :${this.camelTokKebab(key)}='${value}' `;
        }
      });

      let generateComponentId = generateHash()
      let componentResult = `<${componentName} id="editor-component-${generateComponentId}" ${propsResult}  data-component="true"  data-raw-data='${componentRawJson}'  >${componentName}</${componentName}>`;

      const editor = this.$refs.tinymceEditor.editor;
      if (!editor) return;


      if (this.selected_component_mode) {
        const editor = this.$refs.tinymceEditor.editor;
        const newNode = editor.dom.create('div', {}, componentResult).firstChild
        editor.dom.replace(newNode, this.selected_component_mode);
        this.selected_component_mode = null
      } else {
        editor.execCommand('mceInsertContent', false, componentResult);
        this.selected_component_mode = null
      }

      this.selected_component_mode = null

      this.$refs['add-component'].hide()

    },
    moveItem(arrayItem, index, mode = 'up') {

      if (mode === 'up') {
        if (index > 0) {
          arrayItem.splice(index - 1, 1, arrayItem.splice(index, 1, arrayItem[index - 1])[0]);
        }
      }
      if (mode === 'down') {
        if (index < arrayItem.length - 1) {
          arrayItem.splice(index + 1, 1, arrayItem.splice(index, 1, arrayItem[index + 1])[0]);
        }

      }
    },
    removeItem(arrayItem, index,) {
      arrayItem.splice(index, 1)
    },
    setAuthor(item) {
      this.form.author = item
    },
    setAuthorContribute(items) {
      this.form.author_contributes = items
    }
  },
  async mounted() {
    await this.$store.dispatch("Category/getDashboardCategories");

    this.form.created_at = this.nowData()

    setTimeout(async () => {
      await this.setContent()
    }, 500)
    document.addEventListener("keydown", this.handleEscape);


    this.waitForTinyMCE()

    this.$store.dispatch("Category/getDashboardCategories").then(() => {
      setTimeout(() => {
        this.setContent();
      }, 500);
    });

  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleEscape);
  },
};
</script>
<style scoped>


.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}


</style>
